declare global {
    interface Window {
        onYouTubeIframeAPIReady?: () => void;
        YT?: {
            Player?: any;
            [key: string]: any;
        };
    }
}

let youtubeApiReadyPromise: Promise<void>;
/**
 * I case the YouTube Iframe API is not loaded yet, this function will return a promise that resolves when the API is ready.
 * If the API is already loaded, it will return a resolved promise immediately.
 * @returns A promise that resolves when the YouTube Iframe API is ready.
 */
export function waitForYouTubeApi() {
    if (window.YT && window.YT.Player) {
        return Promise.resolve();
    }
    if (!youtubeApiReadyPromise) {
        youtubeApiReadyPromise = new Promise((resolve) => {
            //This function is called by the YouTube Iframe API when it is ready.
            //https://developers.google.com/youtube/iframe_api_reference#Requirements
            window.onYouTubeIframeAPIReady = () => resolve();
        });
    }
    return youtubeApiReadyPromise;
}